import { useEffect } from "react";
import useNotificationsStore from "@stores/shared/useNotificationsStore";
import { useAuth } from "@context/shared/AuthContext";
import { isAccreditor } from "@config/shared/roles";

export const NotificationPoller = () => {
  const { isAuthenticated, user } = useAuth();
  const { fetchItems } = useNotificationsStore();

  useEffect(() => {
    // Accreditors have no notifications UI (NotificationsButton is hidden
    // for that role), and the endpoint 403s for it — skip polling entirely.
    if (!isAuthenticated || isAccreditor(user?.roleId)) return;

    const fetchNotifications = async () => {
      try {
        await fetchItems();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 5 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, [isAuthenticated, user, fetchItems]);

  return null;
};
